import type { NormalizedNullableResponse } from '../../api/ems';

export function normalizeNullable<T>(value: T): NormalizedNullableResponse<T> {
  return normalize(value) as NormalizedNullableResponse<T>;
}

function normalize(value: unknown): unknown {
  if (value === undefined) {
    return null;
  }

  if (Array.isArray(value)) {
    return value.map(normalize);
  }

  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, normalize(item)]),
    );
  }

  return value;
}
